<template>
  <section :data-epi-content-id="isEditable ? expandedContent?.contentLink?.guidValue : null" :class="sectionClass">
    <component
      :is="HtmlBlock"
      v-if="expandedHtmlBlock"
      :block="expandedHtmlBlock"
      :form-container-class="formContainerClass"
    />

    <component :is="FamilyPageTabBlock" v-else-if="familyPageTabBlock" :block="familyPageTabBlock" />

    <component
      :is="FamilyPageSubgroupBlock"
      v-else-if="familyPageSubgroupBlock"
      :block="familyPageSubgroupBlock"
      :universal-products="[]"
      :imperial-products="[]"
      :metric-products="[]"
      :japanese-products="[]"
      :products-length="0"
    />

    <component
      :is="FamilyPageFeedbackTabBlock"
      v-else-if="familyPageFeedbackTabBlock"
      :block="familyPageFeedbackTabBlock"
    />
    <component
      :is="FamilyPageRelatedItemBlock"
      v-else-if="familyPageRelatedItemBlock"
      :block="familyPageRelatedItemBlock"
    />
    <component
      :is="FamilyPageProductsListBlock"
      v-else-if="familyPageProductsListBlock"
      :block="familyPageProductsListBlock"
    />
    <component
      :is="FamilyPageProductsListTableBlock"
      v-else-if="familyPageProductsListTableBlock"
      :block="familyPageProductsListTableBlock"
    />
    <component :is="ResponsiveImageBlock" v-else-if="responsiveImageBlock" :block="responsiveImageBlock" />
    <component :is="ImageRegionsBlock" v-else-if="imageRegionsBlock" :block="imageRegionsBlock" />
    <component :is="TabContainerBlock" v-else-if="expandedTabContainerBlock" :block="expandedTabContainerBlock" />
    <component :is="BannerBlock" v-else-if="bannerBlock" :block="bannerBlock" />
    <component :is="AdBlock" v-else-if="adBlock" :block="adBlock" />
    <component
      :is="DynamicFormBlock"
      v-else-if="formContainerBlock"
      :form-name="formContainerBlock.name"
      styled
      :container-class="formContainerClass"
    />
    <component :is="VisualNavigationBoxBlock" v-else-if="visualNavigationBoxBlock" :box="visualNavigationBoxBlock" />
    <component :is="SoftwarePageTabBlock" v-else-if="softwarePageTabBlock" :block="softwarePageTabBlock" />
    <component
      :is="SoftwarePageSectionBlock"
      v-else-if="softwarePageSectionBlock"
      :block="softwarePageSectionBlock"
      is-open
    />
    <component :is="TradeshowBlock" v-else-if="tradeshowBlock" :block="tradeshowBlock" />
    <component :is="LocationBlock" v-else-if="locationBlock" :block="locationBlock" />
    <component :is="DistributorLocationBlock" v-else-if="distributorLocationBlock" :block="distributorLocationBlock" />
    <component :is="ProductCategoriesBlock" v-else-if="productCategoriesBlock" :block="productCategoriesBlock" />
    <component :is="ProductsContainerBlock" v-else-if="productsContainerBlock" :block="productsContainerBlock" />
    <component :is="ProductFamilyCardBlock" v-else-if="productFamilyCardBlock" :block="productFamilyCardBlock" />
    <component :is="SideBySideBlock" v-else-if="sideBySideBlock" :block="sideBySideBlock" />
    <component
      :is="TextBlocksSideBySideBlock"
      v-else-if="textBlocksSideBySideBlock"
      :block="textBlocksSideBySideBlock"
    />
    <component
      :is="AdditionalContentContainerBlock"
      v-else-if="additionalContentContainerBlock"
      :block="additionalContentContainerBlock"
    />
    <component :is="AdditionalContentBlock" v-else-if="additionalContentBlock" :block="additionalContentBlock" />
    <component :is="CardsContainerBlock" v-else-if="cardsContainerBlock" :block="cardsContainerBlock" />
    <component :is="TextCardBlock" v-else-if="textCardBlock" :block="textCardBlock" />
    <component :is="ImageCardBlock" v-else-if="imageCardBlock" :block="imageCardBlock" />
    <component :is="VideoCardBlock" v-else-if="videoCardBlock" :block="videoCardBlock" />
    <component :is="AlertBlock" v-else-if="alertBlock" :block="alertBlock" />
    <component :is="FeaturedContainerBlock" v-else-if="featuredContainerBlock" :block="featuredContainerBlock" />
    <component :is="FeaturedTradeshowBlock" v-else-if="featuredTradeshowBlock" :block="featuredTradeshowBlock" />
    <component :is="FeaturedContentBlock" v-else-if="featuredContentBlock" :block="featuredContentBlock" />
    <component :is="TwoImagesBlock" v-else-if="twoImagesBlock" :block="twoImagesBlock" />
    <component :is="TitleTextBlock" v-else-if="titleTextBlock" :block="titleTextBlock" />
    <component :is="TitleTextSectionBlock" v-else-if="titleTextSectionBlock" :block="titleTextSectionBlock" />
    <component :is="TimelineBlock" v-else-if="timelineBlock" :block="timelineBlock" />
    <component :is="TimelineStepBlock" v-else-if="timelineStepBlock" :block="timelineStepBlock" />
    <component :is="CollapsibleBlock" v-else-if="collapsibleBlock" :block="collapsibleBlock" />
    <component
      :is="CollapsibleContainerBlock"
      v-else-if="collapsibleContainerBlock"
      :block="collapsibleContainerBlock"
    />
    <component :is="TitleTextVariantBlock" v-else-if="titleTextVariantBlock" :block="titleTextVariantBlock" />
    <component
      :is="TitleTextVariantSectionBlock"
      v-else-if="titleTextVariantSectionBlock"
      :block="titleTextVariantSectionBlock"
    />
    <component
      :is="TitleTextVariantSectionLeftParagraphBlock"
      v-else-if="titleTextVariantSectionLeftParagraphBlock"
      :block="titleTextVariantSectionLeftParagraphBlock"
    />

    <component :is="MobileLabHomeTabBlock" v-else-if="mobileLabHomeBlock" :block="mobileLabHomeBlock" />
    <component :is="MobileLabGalleryTabBlock" v-else-if="mobileLabGalleryTabBlock" :block="mobileLabGalleryTabBlock" />
    <component
      :is="MobileLabFeedbackTabBlock"
      v-else-if="mobileLabFeedbackTabBlock"
      :block="mobileLabFeedbackTabBlock"
    />
    <component
      :is="MobileLabStudentExperienceTabBlock"
      v-else-if="mobileLabStudentExperienceTabBlock"
      :block="mobileLabStudentExperienceTabBlock"
    />
    <component
      :is="MobileLabCalendarTabBlock"
      v-else-if="mobileLabCalendarTabBlock"
      :block="mobileLabCalendarTabBlock"
    />
    <component
      :is="MobileLabOrganizerResourcesTabBlock"
      v-else-if="mobileLabOrganizerResourcesTabBlock"
      :block="mobileLabOrganizerResourcesTabBlock"
    />
    <component
      :is="MobileLabHomeRequestTabBlock"
      v-else-if="mobileLabHomeRequestTabBlock"
      :block="mobileLabHomeRequestTabBlock"
    />
    <component
      :is="MobileLabHomeUpcomingVisitsListBlock"
      v-else-if="mobileLabHomeUpcomingVisitsListBlock"
      :block="mobileLabHomeUpcomingVisitsListBlock"
    />
    <component
      :is="MobileLabHomeIconsListBlock"
      v-else-if="mobileLabHomeIconsListBlock"
      :block="mobileLabHomeIconsListBlock"
    />
    <component
      :is="MobileLabHomeGalleryCarouselBlock"
      v-else-if="mobileLabHomeGalleryCarouselBlock"
      :block="mobileLabHomeGalleryCarouselBlock"
    />
    <component :is="MobileLabHomeMapBlock" v-else-if="mobileLabHomeMapBlock" :block="mobileLabHomeMapBlock" />
    <component :is="MobileLabFooterBlock" v-else-if="mobileLabFooterBlock" :block="mobileLabFooterBlock" />
    <component
      :is="MobileLabCalendarUpcomingAndPastEventsBlock"
      v-else-if="mobileLabCalendarUpcomingAndPastEventsBlock"
      :block="mobileLabCalendarUpcomingAndPastEventsBlock"
    />
    <component
      :is="MobileLabGalleryContainerBlock"
      v-else-if="mobileLabGalleryContainerBlock"
      :block="mobileLabGalleryContainerBlock"
    />
    <component :is="PersonCardBlock" v-else-if="personCardBlock" :block="personCardBlock" />
    <component :is="PersonContactCardBlock" v-else-if="personContactCardBlock" :block="personContactCardBlock" />
    <component
      :is="PersonContactCardContainerBlock"
      v-else-if="personContactCardContainerBlock"
      :block="personContactCardContainerBlock"
    />
    <component
      :is="PersonContactCardCurrencySpecificContainerBlock"
      v-else-if="personContactCardCurrencySpecificContainerBlock"
      :block="personContactCardCurrencySpecificContainerBlock"
    />
    <component :is="BackgroundImageCardBlock" v-else-if="backgroundImageCardBlock" :block="backgroundImageCardBlock" />
    <component :is="PersonCardContainerBlock" v-else-if="personCardContainerBlock" :block="personCardContainerBlock" />
    <component :is="TwoColumnsContainerBlock" v-else-if="twoColumnsContainerBlock" :block="twoColumnsContainerBlock" />
    <component
      :is="BackgroundImageCardContainerBlock"
      v-else-if="backgroundImageCardContainerBlock"
      :block="backgroundImageCardContainerBlock"
    />
    <component :is="ExpandableTwoImagesBlock" v-else-if="expandableTwoImagesBlock" :block="expandableTwoImagesBlock" />
    <component :is="SimpleCallToActionBlock" v-else-if="simpleCallToActionBlock" :block="simpleCallToActionBlock" />
    <component :is="DiscountPricePolicyBlock" v-else-if="discountPricePolicyBlock" :block="discountPricePolicyBlock" />
    <component
      :is="DiscountPricePolicyColumnBlock"
      v-else-if="discountPricePolicyColumnBlock"
      :block="discountPricePolicyColumnBlock"
    />
    <component :is="LocationBenefitBlock" v-else-if="locationBenefitBlock" :block="locationBenefitBlock" />
  </section>
</template>

<script lang="ts" setup>
import { computed, defineAsyncComponent } from "vue";
import { useEditMode } from "@/shared/thorlabs/shared/composables";
import type { IVisualNavigationBox } from "../../visual-navigation";
import type {
  IHtmlBlock,
  IVirtoHtmlBlock,
  ITabContainerBlock,
  IResponsiveImageBlock,
  IBannerBlock,
  IAdBlock,
  ISideBySideBlock,
  ITextBlocksSideBySideBlock,
  IProductCategoriesBlock,
  IProductsContainerBlock,
  IProductFamilyCardBlock,
  IAdditionalContentContainerBlock,
  IAdditionalContentBlock,
  ICardsContainerBlock,
  ITextCardBlock,
  IImageCardBlock,
  IVideoCardBlock,
  IAlertBlock,
  IFeaturedContainerBlock,
  IFeaturedTradeshowBlock,
  IFeaturedContentBlock,
  IBackgroundImageCardBlock,
  IPersonCardBlock,
  IPersonContactCardBlock,
  IPersonContactCardContainerBlock,
  IPersonContactCardCurrencySpecificContainerBlock,
  IBackgroundImageCardContainerBlock,
  IPersonCardContainerBlock,
  ITwoColumnsContainerBlock,
  ISimpleCallToActionBlock,
  ITwoImagesBlock,
  ITitleTextBlock,
  ITitleTextSectionBlock,
  ITitleTextVariantBlock,
  ITitleTextVariantSectionBlock,
  ITitleTextVariantSectionLeftParagraphBlock,
  ITimelineBlock,
  ITimelineStepBlock,
  ICollapsibleBlock,
  ICollapsibleContainerBlock,
  ILocationBenefitBlock,
} from "@/shared/thorlabs/blocks";
import type {
  IDiscountPricePolicyBlock,
  IDiscountPricePolicyColumnBlock,
} from "@/shared/thorlabs/discount-policy-page";
import type { IDistributorLocationBlock } from "@/shared/thorlabs/distributors-page";
import type { IImageRegionsBlock } from "@/shared/thorlabs/image-regions/types";
import type { ILocationBlock } from "@/shared/thorlabs/locations-page";
import type {
  IMobileLabCalendarTabBlock,
  IMobileLabFeedbackTabBlock,
  IMobileLabGalleryTabBlock,
  IMobileLabHomeIconsListBlock,
  IMobileLabHomeTabBlock,
  IMobileLabHomeUpcomingVisitsListBlock,
  IMobileLabOrganizerResourcesTabBlock,
  IMobileLabRequestTabBlock,
  IMobileLabStudentExperienceTabBlock,
  IMobileLabHomeGalleryCarouselBlock,
  IMobileLabHomeMapBlock,
  IMobileLabFooterBlock,
  IMobileLabCalendarUpcomingAndPastEventsBlock,
  IMobileLabGalleryContainerBlock,
} from "@/shared/thorlabs/mobile-lab-page/types";
import type {
  IFamilyPageTab,
  IFamilyPageSubgroup,
  IFamilyPageRelatedItem,
  IProductsList,
  IProductsListTable,
  IFamilyPageFeedbackTab,
} from "@/shared/thorlabs/product-family";
import type { IContentAreaItem, IContent } from "@/shared/thorlabs/shared";
import type { ISoftwarePageTab, ISoftwarePageSection } from "@/shared/thorlabs/software-page/types";
import type { ITradeshowBlockWithUIState } from "@/shared/thorlabs/tradeshows-page";
import type { IExpandableTwoImagesBlock } from "@/shared/thorlabs/blocks/expandable-two-images-block.vue";

const props = withDefaults(defineProps<IProps>(), {
  contentAreaItem: undefined,
  sectionClass: "",
  formContainerClass: "",
});

interface IProps {
  contentAreaItem?: IContentAreaItem<IContent>;
  sectionClass?: string;
  formContainerClass?: string;
}

const HtmlBlock = defineAsyncComponent(() => import("@/shared/thorlabs/blocks/html-block.vue"));
const ResponsiveImageBlock = defineAsyncComponent(() => import("@/shared/thorlabs/blocks/responsive-image-block.vue"));
const ImageRegionsBlock = defineAsyncComponent(
  () => import("@/shared/thorlabs/image-regions/components/image-regions-block.vue"),
);
const TabContainerBlock = defineAsyncComponent(() => import("@/shared/thorlabs/blocks/tab-container-block.vue"));
const BannerBlock = defineAsyncComponent(
  () => import("@/shared/layout/components/header/_internal/banner-alert-header.vue"),
);
const FamilyPageTabBlock = defineAsyncComponent(
  () => import("@/shared/thorlabs/product-family/components/family-page-tab-block.vue"),
);
const FamilyPageSubgroupBlock = defineAsyncComponent(
  () => import("@/shared/thorlabs/product-family/components/family-page-subgroup-block.vue"),
);

const FamilyPageFeedbackTabBlock = defineAsyncComponent(
  () => import("@/shared/thorlabs/product-family/components/family-page-feedback-tab-block.vue"),
);
const FamilyPageRelatedItemBlock = defineAsyncComponent(
  () => import("@/shared/thorlabs/product-family/components/family-page-related-item-block.vue"),
);
const FamilyPageProductsListBlock = defineAsyncComponent(
  () => import("@/shared/thorlabs/product-family/components/family-page-products-list-block.vue"),
);
const FamilyPageProductsListTableBlock = defineAsyncComponent(
  () => import("@/shared/thorlabs/product-family/components/family-page-products-list-table-block.vue"),
);
const VisualNavigationBoxBlock = defineAsyncComponent(
  () => import("@/shared/thorlabs/visual-navigation/components/visnav-box-block.vue"),
);

const AdBlock = defineAsyncComponent(() => import("@/shared/thorlabs/blocks/ad-block.vue"));
const DynamicFormBlock = defineAsyncComponent(
  () => import("@/shared/thorlabs/shared/components/dynamic-form-block.vue"),
);

const SoftwarePageTabBlock = defineAsyncComponent(
  () => import("@/shared/thorlabs/software-page/components/software-page-tab-block.vue"),
);
const SoftwarePageSectionBlock = defineAsyncComponent(
  () => import("@/shared/thorlabs/software-page/components/software-page-section-block.vue"),
);

const ProductCategoriesBlock = defineAsyncComponent(
  () => import("@/shared/thorlabs/blocks/product-categories-block.vue"),
);

const ProductsContainerBlock = defineAsyncComponent(
  () => import("@/shared/thorlabs/blocks/products-container-block.vue"),
);
const ProductFamilyCardBlock = defineAsyncComponent(
  () => import("@/shared/thorlabs/blocks/product-family-card-block.vue"),
);

const SideBySideBlock = defineAsyncComponent(() => import("@/shared/thorlabs/blocks/side-by-side-block.vue"));
const TextBlocksSideBySideBlock = defineAsyncComponent(
  () => import("@/shared/thorlabs/blocks/text-blocks-side-by-side-block.vue"),
);

const AdditionalContentContainerBlock = defineAsyncComponent(
  () => import("@/shared/thorlabs/blocks/additional-content-container-block.vue"),
);
const AdditionalContentBlock = defineAsyncComponent(
  () => import("@/shared/thorlabs/blocks/additional-content-block.vue"),
);
const CardsContainerBlock = defineAsyncComponent(() => import("@/shared/thorlabs/blocks/cards-container-block.vue"));
const TextCardBlock = defineAsyncComponent(() => import("@/shared/thorlabs/blocks/text-card-block.vue"));
const ImageCardBlock = defineAsyncComponent(() => import("@/shared/thorlabs/blocks/image-card-block.vue"));
const VideoCardBlock = defineAsyncComponent(() => import("@/shared/thorlabs/blocks/video-card-block.vue"));
const AlertBlock = defineAsyncComponent(() => import("@/shared/thorlabs/blocks/alert-block.vue"));
const FeaturedContainerBlock = defineAsyncComponent(
  () => import("@/shared/thorlabs/blocks/featured-container-block.vue"),
);
const FeaturedTradeshowBlock = defineAsyncComponent(
  () => import("@/shared/thorlabs/blocks/featured-tradeshow-block.vue"),
);
const FeaturedContentBlock = defineAsyncComponent(() => import("@/shared/thorlabs/blocks/featured-content-block.vue"));
const TwoImagesBlock = defineAsyncComponent(() => import("@/shared/thorlabs/blocks/two-images-block.vue"));
const TitleTextBlock = defineAsyncComponent(() => import("@/shared/thorlabs/blocks/title-text-block.vue"));
const TitleTextSectionBlock = defineAsyncComponent(
  () => import("@/shared/thorlabs/blocks/title-text-section-block.vue"),
);
const TimelineBlock = defineAsyncComponent(() => import("@/shared/thorlabs/blocks/timeline/timeline-block.vue"));
const TimelineStepBlock = defineAsyncComponent(
  () => import("@/shared/thorlabs/blocks/timeline/timeline-step-block.vue"),
);
const CollapsibleBlock = defineAsyncComponent(
  () => import("@/shared/thorlabs/blocks/collapsible/collapsible-block.vue"),
);
const CollapsibleContainerBlock = defineAsyncComponent(
  () => import("@/shared/thorlabs/blocks/collapsible/collapsible-container-block.vue"),
);
const TitleTextVariantBlock = defineAsyncComponent(
  () => import("@/shared/thorlabs/blocks/title-text-variant/title-text-variant-block.vue"),
);
const TitleTextVariantSectionBlock = defineAsyncComponent(
  () => import("@/shared/thorlabs/blocks/title-text-variant/title-text-variant-section-block.vue"),
);
const TitleTextVariantSectionLeftParagraphBlock = defineAsyncComponent(
  () => import("@/shared/thorlabs/blocks/title-text-variant/title-text-variant-section-left-paragraph-block.vue"),
);

const TradeshowBlock = defineAsyncComponent(
  () => import("@/shared/thorlabs/tradeshows-page/components/tradeshow-block.vue"),
);
const LocationBlock = defineAsyncComponent(
  () => import("@/shared/thorlabs/locations-page/components/location-block.vue"),
);

const DistributorLocationBlock = defineAsyncComponent(
  () => import("@/shared/thorlabs/distributors-page/components/distributor-location-block.vue"),
);

const PersonCardBlock = defineAsyncComponent(() => import("@/shared/thorlabs/blocks/person-card-block.vue"));
const PersonContactCardBlock = defineAsyncComponent(
  () => import("@/shared/thorlabs/blocks/person-contact-card-block.vue"),
);
const PersonContactCardContainerBlock = defineAsyncComponent(
  () => import("@/shared/thorlabs/blocks/person-contact-card-container-block.vue"),
);
const PersonContactCardCurrencySpecificContainerBlock = defineAsyncComponent(
  () => import("@/shared/thorlabs/blocks/person-contact-card-currency-specific-container-block.vue"),
);
const BackgroundImageCardBlock = defineAsyncComponent(
  () => import("@/shared/thorlabs/blocks/background-image-card-block.vue"),
);
const PersonCardContainerBlock = defineAsyncComponent(
  () => import("@/shared/thorlabs/blocks/person-card-container-block.vue"),
);
const TwoColumnsContainerBlock = defineAsyncComponent(
  () => import("@/shared/thorlabs/blocks/two-columns-container-block.vue"),
);
const BackgroundImageCardContainerBlock = defineAsyncComponent(
  () => import("@/shared/thorlabs/blocks/background-image-card-container-block.vue"),
);
const ExpandableTwoImagesBlock = defineAsyncComponent(
  () => import("@/shared/thorlabs/blocks/expandable-two-images-block.vue"),
);
const SimpleCallToActionBlock = defineAsyncComponent(
  () => import("@/shared/thorlabs/blocks/simple-call-to-action-block.vue"),
);
const MobileLabHomeTabBlock = defineAsyncComponent(
  () => import("@/shared/thorlabs/mobile-lab-page/components/mobile-lab-home-tab-block.vue"),
);
const MobileLabGalleryTabBlock = defineAsyncComponent(
  () => import("@/shared/thorlabs/mobile-lab-page/components/mobile-lab-gallery-tab-block.vue"),
);
const MobileLabFeedbackTabBlock = defineAsyncComponent(
  () => import("@/shared/thorlabs/mobile-lab-page/components/mobile-lab-feedback-tab-block.vue"),
);
const MobileLabStudentExperienceTabBlock = defineAsyncComponent(
  () => import("@/shared/thorlabs/mobile-lab-page/components/mobile-lab-student-experience-tab-block.vue"),
);
const MobileLabCalendarTabBlock = defineAsyncComponent(
  () => import("@/shared/thorlabs/mobile-lab-page/components/mobile-lab-calendar-tab-block.vue"),
);
const MobileLabOrganizerResourcesTabBlock = defineAsyncComponent(
  () => import("@/shared/thorlabs/mobile-lab-page/components/mobile-lab-organizer-resources-tab-block.vue"),
);
const MobileLabHomeRequestTabBlock = defineAsyncComponent(
  () => import("@/shared/thorlabs/mobile-lab-page/components/mobile-lab-request-tab-block.vue"),
);
const MobileLabHomeUpcomingVisitsListBlock = defineAsyncComponent(
  () => import("@/shared/thorlabs/mobile-lab-page/components/mobile-lab-home-upcoming-visits-list-block.vue"),
);
const MobileLabHomeIconsListBlock = defineAsyncComponent(
  () => import("@/shared/thorlabs/mobile-lab-page/components/mobile-lab-home-icons-list-block.vue"),
);
const MobileLabHomeGalleryCarouselBlock = defineAsyncComponent(
  () => import("@/shared/thorlabs/mobile-lab-page/components/mobile-lab-home-gallery-carousel-block.vue"),
);
const MobileLabHomeMapBlock = defineAsyncComponent(
  () => import("@/shared/thorlabs/mobile-lab-page/components/mobile-lab-home-map-block.vue"),
);
const MobileLabFooterBlock = defineAsyncComponent(
  () => import("@/shared/thorlabs/mobile-lab-page/components/mobile-lab-footer-block.vue"),
);
const MobileLabCalendarUpcomingAndPastEventsBlock = defineAsyncComponent(
  () => import("@/shared/thorlabs/mobile-lab-page/components/mobile-lab-calendar-upcoming-and-past-events-block.vue"),
);
const MobileLabGalleryContainerBlock = defineAsyncComponent(
  () => import("@/shared/thorlabs/mobile-lab-page/components/mobile-lab-gallery-container-block.vue"),
);
const DiscountPricePolicyBlock = defineAsyncComponent(
  () => import("@/shared/thorlabs/discount-policy-page/components/discount-price-policy-block.vue"),
);
const DiscountPricePolicyColumnBlock = defineAsyncComponent(
  () => import("@/shared/thorlabs/discount-policy-page/components/discount-price-policy-column-block.vue"),
);

const LocationBenefitBlock = defineAsyncComponent(() => import("@/shared/thorlabs/blocks/location-benefit-block.vue"));

const isEditable = computed(() => useEditMode().isEditable.value);
const expandedContent = computed(() => props.contentAreaItem?.contentLink?.expanded);
const contentType = computed(() => expandedContent.value?.contentType?.at(-1));
const imageRegionsBlock = computed(() =>
  contentType.value === "ImageRegionsBlock" ? (expandedContent.value as IImageRegionsBlock) : false,
);

const expandedHtmlBlock = computed(() => {
  return contentType.value === "HtmlBlock"
    ? (expandedContent.value as IHtmlBlock)
    : contentType.value === "VirtoHtmlBlock"
      ? (expandedContent.value as IVirtoHtmlBlock)
      : false;
});

const expandedTabContainerBlock = computed(() => {
  return contentType.value === "TabContainerBlock" ? (expandedContent.value as ITabContainerBlock) : false;
});

const responsiveImageBlock = computed(() => {
  return contentType.value === "ResponsiveImageBlock" ? (expandedContent.value as IResponsiveImageBlock) : false;
});

const bannerBlock = computed(() => {
  return contentType.value === "BannerBlock" ? (expandedContent.value as IBannerBlock) : false;
});

const familyPageSubgroupBlock = computed(() => {
  return contentType.value === "SubgroupBlock" ? (expandedContent.value as IFamilyPageSubgroup) : false;
});

const familyPageTabBlock = computed(() => {
  return contentType.value === "FamilyPageTabBlock" ? (expandedContent.value as IFamilyPageTab) : false;
});

const familyPageFeedbackTabBlock = computed(() => {
  return contentType.value === "FamilyPageFeedbackTab" ? (expandedContent.value as IFamilyPageFeedbackTab) : false;
});

const familyPageRelatedItemBlock = computed(() => {
  return contentType.value === "FamilyPageRelatedItemBlock" ? (expandedContent.value as IFamilyPageRelatedItem) : false;
});

const familyPageProductsListBlock = computed(() => {
  return contentType.value === "ProductsListBlock" ? (expandedContent.value as IProductsList) : false;
});

const familyPageProductsListTableBlock = computed(() => {
  return contentType.value === "ProductsListTableBlock" ? (expandedContent.value as IProductsListTable) : false;
});

const adBlock = computed(() => {
  return contentType.value === "AdBlock" ? (expandedContent.value as IAdBlock) : false;
});

const formContainerBlock = computed(() => {
  return contentType.value === "FormContainerBlock" ? expandedContent.value : false;
});

const visualNavigationBoxBlock = computed(() => {
  return contentType.value === "VisualNavigationBoxBlock"
    ? (props.contentAreaItem as IContentAreaItem<IVisualNavigationBox>)
    : false;
});

const softwarePageTabBlock = computed(() => {
  return contentType.value === "SoftwarePageTabBlock" ? (expandedContent.value as ISoftwarePageTab) : false;
});

const tradeshowBlock = computed(() => {
  return contentType.value === "TradeshowBlock" ? (expandedContent.value as ITradeshowBlockWithUIState) : false;
});

const softwarePageSectionBlock = computed(() => {
  return contentType.value === "SoftwarePageSectionBlock" ? (expandedContent.value as ISoftwarePageSection) : false;
});

const locationBlock = computed(() => {
  return contentType.value === "LocationBlock" ? (expandedContent.value as ILocationBlock) : false;
});

const distributorLocationBlock = computed(() => {
  return contentType.value === "DistributorLocationBlock"
    ? (expandedContent.value as IDistributorLocationBlock)
    : false;
});

const productCategoriesBlock = computed(() => {
  return contentType.value === "ProductCategoriesBlock" ? (expandedContent.value as IProductCategoriesBlock) : false;
});

const productsContainerBlock = computed(() => {
  return contentType.value === "ProductsContainerBlock" ? (expandedContent.value as IProductsContainerBlock) : false;
});

const productFamilyCardBlock = computed(() => {
  return contentType.value === "ProductFamilyCardBlock" ? (expandedContent.value as IProductFamilyCardBlock) : false;
});

const sideBySideBlock = computed(() => {
  return contentType.value === "SideBySideBlock" ? (expandedContent.value as ISideBySideBlock) : false;
});
const textBlocksSideBySideBlock = computed(() => {
  return contentType.value === "TextBlocksSideBySideBlock"
    ? (expandedContent.value as ITextBlocksSideBySideBlock)
    : false;
});
const simpleCallToActionBlock = computed(() => {
  return contentType.value === "SimpleCallToActionBlock" ? (expandedContent.value as ISimpleCallToActionBlock) : false;
});

const additionalContentContainerBlock = computed(() => {
  return contentType.value === "AdditionalContentContainerBlock"
    ? (expandedContent.value as IAdditionalContentContainerBlock)
    : false;
});
const additionalContentBlock = computed(() => {
  return contentType.value === "AdditionalContentBlock" ? (expandedContent.value as IAdditionalContentBlock) : false;
});

const cardsContainerBlock = computed(() => {
  return contentType.value === "CardsContainerBlock" ? (expandedContent.value as ICardsContainerBlock) : false;
});
const textCardBlock = computed(() => {
  return contentType.value === "TextCardBlock" ? (expandedContent.value as ITextCardBlock) : false;
});
const imageCardBlock = computed(() => {
  return contentType.value === "ImageCardBlock" ? (expandedContent.value as IImageCardBlock) : false;
});
const videoCardBlock = computed(() => {
  return contentType.value === "VideoCardBlock" ? (expandedContent.value as IVideoCardBlock) : false;
});

const alertBlock = computed(() => {
  return contentType.value === "AlertBlock" ? (expandedContent.value as IAlertBlock) : false;
});

const featuredContainerBlock = computed(() => {
  return contentType.value === "FeaturedContainerBlock" ? (expandedContent.value as IFeaturedContainerBlock) : false;
});
const featuredTradeshowBlock = computed(() => {
  return contentType.value === "FeaturedTradeshowBlock" ? (expandedContent.value as IFeaturedTradeshowBlock) : false;
});
const featuredContentBlock = computed(() => {
  return contentType.value === "FeaturedContentBlock" ? (expandedContent.value as IFeaturedContentBlock) : false;
});
const twoImagesBlock = computed(() => {
  return contentType.value === "TwoImagesBlock" ? (expandedContent.value as ITwoImagesBlock) : false;
});
const titleTextBlock = computed(() => {
  return contentType.value === "TitleTextBlock" ? (expandedContent.value as ITitleTextBlock) : false;
});
const titleTextSectionBlock = computed(() => {
  return contentType.value === "TitleTextSectionBlock" ? (expandedContent.value as ITitleTextSectionBlock) : false;
});
const titleTextVariantBlock = computed(() => {
  return contentType.value === "TitleTextVariantBlock" ? (expandedContent.value as ITitleTextVariantBlock) : false;
});
const titleTextVariantSectionBlock = computed(() => {
  return contentType.value === "TitleTextVariantSectionBlock"
    ? (expandedContent.value as ITitleTextVariantSectionBlock)
    : false;
});
const titleTextVariantSectionLeftParagraphBlock = computed(() => {
  return contentType.value === "TitleTextVariantSectionLeftParagraphBlock"
    ? (expandedContent.value as ITitleTextVariantSectionLeftParagraphBlock)
    : false;
});
const timelineBlock = computed(() => {
  return contentType.value === "TimelineBlock" ? (expandedContent.value as ITimelineBlock) : false;
});
const timelineStepBlock = computed(() => {
  return contentType.value === "TimelineStepBlock" ? (expandedContent.value as ITimelineStepBlock) : false;
});
const collapsibleBlock = computed(() => {
  return contentType.value === "CollapsibleBlock" ? (expandedContent.value as ICollapsibleBlock) : false;
});
const collapsibleContainerBlock = computed(() => {
  return contentType.value === "CollapsibleContainerBlock"
    ? (expandedContent.value as ICollapsibleContainerBlock)
    : false;
});

const mobileLabHomeBlock = computed(() => {
  return contentType.value === "MobileLabHomeTabBlock" ? (expandedContent.value as IMobileLabHomeTabBlock) : false;
});
const mobileLabGalleryTabBlock = computed(() => {
  return contentType.value === "MobileLabGalleryTabBlock"
    ? (expandedContent.value as IMobileLabGalleryTabBlock)
    : false;
});
const mobileLabFeedbackTabBlock = computed(() => {
  return contentType.value === "MobileLabFeedbackTabBlock"
    ? (expandedContent.value as IMobileLabFeedbackTabBlock)
    : false;
});
const mobileLabStudentExperienceTabBlock = computed(() => {
  return contentType.value === "MobileLabStudentExperienceTabBlock"
    ? (expandedContent.value as IMobileLabStudentExperienceTabBlock)
    : false;
});
const mobileLabCalendarTabBlock = computed(() => {
  return contentType.value === "MobileLabCalendarTabBlock"
    ? (expandedContent.value as IMobileLabCalendarTabBlock)
    : false;
});
const mobileLabOrganizerResourcesTabBlock = computed(() => {
  return contentType.value === "MobileLabOrganizerResourcesTabBlock"
    ? (expandedContent.value as IMobileLabOrganizerResourcesTabBlock)
    : false;
});
const mobileLabHomeRequestTabBlock = computed(() => {
  return contentType.value === "MobileLabRequestTabBlock"
    ? (expandedContent.value as IMobileLabRequestTabBlock)
    : false;
});
const mobileLabHomeUpcomingVisitsListBlock = computed(() => {
  return contentType.value === "MobileLabHomeUpcomingVisitsListBlock"
    ? (expandedContent.value as IMobileLabHomeUpcomingVisitsListBlock)
    : false;
});
const mobileLabHomeIconsListBlock = computed(() => {
  return contentType.value === "MobileLabHomeIconsListBlock"
    ? (expandedContent.value as IMobileLabHomeIconsListBlock)
    : false;
});
const mobileLabHomeGalleryCarouselBlock = computed(() => {
  return contentType.value === "MobileLabHomeGalleryCarouselBlock"
    ? (expandedContent.value as IMobileLabHomeGalleryCarouselBlock)
    : false;
});
const mobileLabHomeMapBlock = computed(() => {
  return contentType.value === "MobileLabHomeMapBlock" ? (expandedContent.value as IMobileLabHomeMapBlock) : false;
});
const mobileLabFooterBlock = computed(() => {
  return contentType.value === "MobileLabFooterBlock" ? (expandedContent.value as IMobileLabFooterBlock) : false;
});
const mobileLabCalendarUpcomingAndPastEventsBlock = computed(() => {
  return contentType.value === "MobileLabCalendarUpcomingAndPastEventsBlock"
    ? (expandedContent.value as IMobileLabCalendarUpcomingAndPastEventsBlock)
    : false;
});
const mobileLabGalleryContainerBlock = computed(() => {
  return contentType.value === "MobileLabGalleryContainerBlock"
    ? (expandedContent.value as IMobileLabGalleryContainerBlock)
    : false;
});

const backgroundImageCardContainerBlock = computed(() => {
  return contentType.value === "BackgroundImageCardContainerBlock"
    ? (expandedContent.value as IBackgroundImageCardContainerBlock)
    : false;
});
const backgroundImageCardBlock = computed(() => {
  return contentType.value === "BackgroundImageCardBlock"
    ? (expandedContent.value as IBackgroundImageCardBlock)
    : false;
});
const personCardContainerBlock = computed(() => {
  return contentType.value === "PersonCardContainerBlock"
    ? (expandedContent.value as IPersonCardContainerBlock)
    : false;
});
const personCardBlock = computed(() => {
  return contentType.value === "PersonCardBlock" ? (expandedContent.value as IPersonCardBlock) : false;
});
const personContactCardBlock = computed(() => {
  return contentType.value === "PersonContactCardBlock" ? (expandedContent.value as IPersonContactCardBlock) : false;
});
const personContactCardContainerBlock = computed(() => {
  return contentType.value === "PersonContactCardContainerBlock"
    ? (expandedContent.value as IPersonContactCardContainerBlock)
    : false;
});
const personContactCardCurrencySpecificContainerBlock = computed(() => {
  return contentType.value === "PersonContactCardCurrencySpecificContainerBlock"
    ? (expandedContent.value as IPersonContactCardCurrencySpecificContainerBlock)
    : false;
});
const twoColumnsContainerBlock = computed(() => {
  return contentType.value === "TwoColumnsContainerBlock"
    ? (expandedContent.value as ITwoColumnsContainerBlock)
    : false;
});

const expandableTwoImagesBlock = computed(() => {
  return contentType.value === "ExpandableTwoImagesBlock"
    ? (expandedContent.value as IExpandableTwoImagesBlock)
    : false;
});
const discountPricePolicyBlock = computed(() => {
  return contentType.value === "DiscountPricePolicyBlock"
    ? (expandedContent.value as IDiscountPricePolicyBlock)
    : false;
});
const discountPricePolicyColumnBlock = computed(() => {
  return contentType.value === "DiscountPricePolicyColumnBlock"
    ? (expandedContent.value as IDiscountPricePolicyColumnBlock)
    : false;
});

const locationBenefitBlock = computed(() => {
  return contentType.value === "LocationBenefitBlock" ? (expandedContent.value as ILocationBenefitBlock) : false;
});
</script>
